import { IMatchState } from "../reduce";

const prepareRowStyles = (
  row: any,
  state: IMatchState,
  hoveredFeature: string,
  bold: boolean
) => {
  const feature = row.feature.toUpperCase();
  let classes = "";

  if (bold) {
    const boldText =
      state.tableWeights[feature] && state.tableWeights[feature] > 0
        ? "content-bold "
        : "";

    classes += boldText;
  }

  const highlightRow = state.highlightedRows.includes(feature)
    ? "highlighted "
    : "";

  classes += highlightRow;

  const highlightOnHover =
    hoveredFeature === feature ? "highlighted-on-hover " : "";

  classes += highlightOnHover;

  return classes;
};

export default prepareRowStyles;
